import { render, staticRenderFns } from "./TabFaq.vue?vue&type=template&id=2cd8fe9c&scoped=true"
import script from "./TabFaq.vue?vue&type=script&lang=js"
export * from "./TabFaq.vue?vue&type=script&lang=js"
import style0 from "./TabFaq.vue?vue&type=style&index=0&id=2cd8fe9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd8fe9c",
  null
  
)

export default component.exports